import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterServiceByNamePipe } from 'src/app/shared/pipes/filter-service-by-name/filter-service-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ServiceModalDetailComponent } from './modal/service-modal-detail/service-modal-detail.component';
import { ServiceModalAjoutComponent } from './modal/service-modal-ajout/service-modal-ajout.component';
import { ListServiceComponent } from './list-service/list-service.component';
import { AccordionComponent } from 'ngx-bootstrap/accordion';

@NgModule({
	declarations: [
		ListServiceComponent,
		ServiceModalDetailComponent,
		ServiceModalAjoutComponent,
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterServiceByNamePipe]
})

export class ServiceModule {}
